@if (data.title) {
<h2 mat-dialog-title>
  {{ data.title }}
</h2>
}
<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions>
<div class="flex justify-end w-full p-3">
  <button mat-button mat-dialog-close>{{ 'cancel' | translate }}</button>
  <button mat-button (click)="onConfirmClick()" cdkFocusInitial>{{ 'proceed' | translate }}</button>
</div>
</mat-dialog-actions>
